export default [
  {
    title: 'Dashboard',
    icon: 'HomeIcon',
    route: 'dashboard-analytics',
    resource: 'dashboard',
    action: 'view',
  },
]
